import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import appConfig from '@/config';
import { masterOperations } from '@/reducks/master';
import Header from './header';
import Sidebar from './sidebar';

/**
 * 共通レイアウト
 */
class AppLayout extends React.Component {
  /**
   * マウント
   */
  async componentDidMount() {

    // マスター情報がなければ取得
    await this.props.loadMasters();
  }

  /**
   * 描画
   */
  render() {
    const { children, sidebarOpen } = this.props;
    return (
      <Box id="main-container"
        sx={{
          display: 'flex',
          height: '100%',
          overflow: 'hidden',
          flexDirection: 'column',
        }}
      >
        {/* ヘッダー */}
        <Header />

        {/* サイドバー */}
        <Sidebar />

        {/* メインエリア */}
        <Stack component="main"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            ml: {
              md: sidebarOpen ? `${appConfig.ui.sidebarWidth}px` : 0
            },
            px: 2,
            pt: 0,
            pb: 2,
          }}
        >
          {children}
        </Stack>
      </Box>
    );
  }
}

// プロパティ
AppLayout.propTypes = {
  children: PropTypes.node,

  // ストア
  sidebarOpen: PropTypes.bool,
  loadMasters: PropTypes.func.isRequired,
};

// ストア接続
const mapStateToProps = (state) => ({
  sidebarOpen: state.sidebar.open,
});
const mapDispatchToProps = {
  loadMasters: masterOperations.loadMasters,
};
AppLayout = connect(mapStateToProps, mapDispatchToProps)(AppLayout);

// エクスポート
export default AppLayout;
